import React, { useState, useEffect } from "react";

import PanelTemplate from "../../templates/Panel";
import DotStatus from "../../components/DotStatus";
import BoxTabs from "../../components/BoxTabs";
import Modal from "../../components/Modal";
import InputSelect from "../../components/InputSelect";
import Input from "../../components/Input";
import InputRadio from "../../components/InputRadio";
import InputEditor from "../../components/InputEditor";
import InputCheckboxes from "../../components/InputCheckboxes";
import PageFooter from "../../components/PageFooter";
import Button from "../../components/Button";
import InputColors from "../../components/InputColors";
import PageHeader from "../../components/PageHeader";
import InputTextarea from "../../components/InputTextarea";
import Table from "../../components/Table";
import { useNavigate, useParams, Link } from "react-router-dom";
import api from "../../services/api";
import { renderError } from "../../helpers/errors";
import { Loading } from "../../components/Loading";
import { createOptions } from "../../helpers/selects";
import states from "../../seeds/states";
import axios from "axios";
import { toast } from "react-toastify";
import { convertIntToMoney, convertMoenyToInt, convertPercentageToFloat, convertPercentageToInt } from "../../helpers/conversions";
import { convertToPercentage } from "../../helpers/masks";
import { ModalDelete } from "../../components/ModalDelete";
import ModalCreateQuote from "../Quote/ModalCreateQuote";
import moment from "moment";
import origins from "../../seeds/origins";
import { hasPermission, getUser } from "../../services/auth";
import InputFile from "../../components/InputFile";

const ORIGINAL_REASON_LABELS = {
    cnpj: 'CNPJ idêntico',
    company_name: 'Razão social idêntica',
    trade_name: 'Nome fantasia idêntico',
    zip_code_number: 'CEP e número do endereço idênticos',
    email_domain: 'Domínio do e-mail do contato idêntico',
    phone: 'Telefone do contato idêntico',
};

const types = [
    {label: 'Fornecedor de gravação', value: 'customization'},
    {label: 'Fornecedor de produto', value: 'product'},
    {label: 'Cliente', value: 'customer'},
    {label: 'Faturamento', value: 'billing'}
];

const QuotesTab = ({quotes}) => {
    const [data, setData] = useState({header: [], rows: []});

    useEffect(() => {
        generateData();
    }, []);

    const generateData = () => {
        const header = ['Código', 'Data da solicitação', 'Status'];
        const rows = [];
        
        quotes.map(quote => {
            rows.push({
                data: [
                    quote.code,
                    moment(quote.created_at).format('DD/MM/YYYY HH:mm'),
                    <>
                        <DotStatus color={quote.status_color} size={15} />
                        {quote.status_name}
                    </>
                ],
                to: `/quote/edit/${quote.id}`
            });
        });

        setData({header, rows});
    }

    return (
        <Table header={data.header} rows={data.rows} />
    );
}

const OrdersTab = ({orders}) => {
    const [data, setData] = useState({header: [], rows: []});

    useEffect(() => {
        generateData();
    }, []);

    const generateData = () => {
        const header = ['Código', 'Data da solicitação', 'Status'];
        const rows = [];
        
        orders.map(order => {
            rows.push({
                data: [
                    order.code,
                    moment(order.created_at).format('DD/MM/YYYY HH:mm'),
                    <>
                        <DotStatus color={order.status_color} size={15} />
                        {order.status_name}
                    </>
                ],
                to: `/order/edit/${order.id}`
            });
        });

        setData({header, rows});
    }

    return (
        <Table header={data.header} rows={data.rows} />
    );
}

const CompanyDetailsTab = ({
    admins, 
    company, 
    type, 
    setType, 
    admin, 
    setAdmin,
    tradeName,
    setTradeName,
    companyName,
    setCompanyName,
    cnpj,
    setCnpj,
    taxPercentage,
    setTaxPercentage,
    zipCode,
    setZipCode,
    street,
    setStreet,
    number,
    setNumber,
    complement,
    setComplement,
    district,
    setDistrict,
    city,
    setCity,
    state,
    setState,
    ie,
    setIe,
    phone,
    setPhone,
    origin,
    setOrigin,
    paperImageBase64,
    setPaperImageBase64,
    paperImageName,
    setPaperImageName
}) => {
    return (
        <div>
            <h2 className="section-title">Dados cadastrais</h2>
            <div className="row">
                <div className="col-2">
                    <Input type={`text`} label={`Código`} value={company.code} disabled={true} />
                </div>
                <div className="col-4">
                    <InputSelect label={`Marcadores`} options={types} value={type} change={setType} isMulti={true} />
                </div>
                {type.includes('customer') &&
                    <div className="col-3">
                        <InputSelect label={`Responsável`} options={createOptions(admins, 'name', 'id', true)} value={admin} change={setAdmin} />
                    </div>
                }
                <div className="col-3">
                    <InputSelect label={`Onde nos conheceu`} options={origins} value={origin} change={setOrigin} />
                </div>
            </div>
            <div className="row">
                <div className="col-4">
                    <Input type={`text`} label={`CNPJ`} value={cnpj} change={setCnpj} mask={`convertToCnpj`} />
                </div>
                <div className="col-4">
                    <Input type={`text`} label={`Nome fantasia`} value={tradeName} change={setTradeName} />
                </div>
                <div className="col-4">
                    <Input type={`text`} label={`Razão social`} value={companyName} change={setCompanyName} />
                </div>
            </div>
            <div className="row">
                <div className="col-4">
                    <Input type={`text`} label={`IE`} value={ie} change={setIe} />
                </div>
                <div className="col-4">
                    <Input type={`text`} label={`Telefone`} value={phone} change={setPhone} mask={`convertToPhone`} />
                </div>
           
                {type.includes('billing') &&
                    <div className="col-4">
                        <Input type={`text`} label={`Imposto`} value={taxPercentage} change={value => setTaxPercentage( convertToPercentage(value) )} />
                    </div>
                }
            </div>
            {type.includes('billing') &&
                <div className="row">
                    <div className="col-4">
                        <InputFile 
                            label={`Fundo dos documentos`} 
                            base64={paperImageBase64}
                            changeBase64={setPaperImageBase64}
                            name={paperImageName}
                            changeName={setPaperImageName}
                        />
                        <a style={{ fontSize: 14, display: 'table', marginTop: -10}} href="/images/timbrado.svg" download>Download do modelo de imagem</a>
                    </div>
                </div>
            }
            <h2 className="section-title">Endereço</h2>
            <div className="row">
                <div className="col-3">
                    <Input type={`text`} label={`CEP`} value={zipCode} change={setZipCode} mask={`convertToCep`} />
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <Input type={`text`} label={`Logradouro`} value={street} change={setStreet} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`Número`} value={number} change={setNumber} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`Complemento`} value={complement} change={setComplement} />
                </div>
            </div>
            <div className="row">
                <div className="col-3">
                    <InputSelect label={`Estado`} options={states} value={state} change={setState} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`Cidade`} value={city} change={setCity} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`Bairro`} value={district} change={setDistrict} />
                </div>
            </div>
        </div>
    );
}

const ContactsTab = ({company, getCompany}) => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showCreate, setShowCreate] = useState(false);

    const [customerId, setCustomerId] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');

    const [customerToDelete, setCustomerToDelete] = useState(null);

    useEffect(() => {
        if(!showEdit) clean();
    }, [showEdit]);

    useEffect(() => {
        if(!showCreate) clean();
    }, [showCreate]);

    const updateContact = () => {
        setLoading(true);
        api.put(`/customer/${customerId}`, {
            name,
            phone,
            email
        }).then(res => {
            toast.success('Pessoa atualizada com sucesso');
            getCompany();
            setShowEdit(false);
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const storeContact = () => {
        setLoading(true);
        
        api.post(`/customer`, {
            company_ids: [company.id],
            name,
            phone,
            email,
            type: company.type
        }).then(res => {
            toast.success('Pessoa cadastrada com sucesso');
            getCompany();
            setShowEdit(false);
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const editContact = customer => {
        navigate(`/customer/edit/${customer.id}`);
        console.log(customer);
        // setCustomerId(customer.id);
        // setName(customer.name);
        // setPhone(customer.phone);
        // setEmail(customer.email);
        // setShowEdit(true);
    }

    const clean = () => {
        setCustomerId('');
        setName('');
        setPhone('');
        setEmail('');
    }

    const header = ['Nome', 'E-mail', 'Telefone', 'Empresa'];
    const rows = [];
    company.customers.map(customer => {
        let companies = customer.companies.map(company => company.trade_name).join(', ');
        rows.push({
            data: [customer.name, customer.email, customer.phone, companies],
            action: () => editContact(customer)
        });
    });

    const createContact = () => {
        setShowCreate(true);
    }

    const deleteCustomer = () => {
        setLoading(true);
        api.delete(`/customer/${customerToDelete}`).then(res => {
            setCustomerToDelete(null);
            getCompany();
        }).catch(error => {
            setLoading(false);
            renderError(error);
        });
    }

    return (
        <>
            
            <Modal
                title={`Editar pessoa`}
                show={showEdit}
                close={() => setShowEdit(false)}
                footer={
                    <>
                        <Button 
                            type={`secondary`} 
                            size={`small`}
                            svg={`delete`} 
                            text={`Excluir`} 
                            loading={loading} 
                            action={() => setCustomerToDelete(customerId)}
                        />
                        <Button 
                            type={`primary`}
                            size={`small`}
                            text={`Salvar alterações`}
                            svg={`save-white`}
                            action={updateContact}
                            loading={loading}
                        />
                    </>
                }
            >
                <div className="section">
                     <div className="row">
                        <div className="col-6">
                            <Input type={`text`} label={`Nome`} change={setName} value={name} />
                        </div>
                    </div>   
                    <div className="row">
                        <div className="col-6">
                            <Input type={`email`} label={`E-mail`} change={setEmail} value={email} />
                        </div>
                    </div>   
                    <div className="row">
                        <div className="col-6">
                            <Input type={`text`} label={`Telefone`} change={setPhone} value={phone} mask={`convertToPhone`} />
                        </div>
                    </div>                 
                </div>
            </Modal>
            <Modal
                title={`Cadastrar pessoa`}
                show={showCreate}
                close={() => setShowCreate(false)}
                footer={
                    <Button 
                        type={`primary`}
                        size={`small`}
                        text={`Cadastrar pessoa`}
                        svg={`save-white`}
                        action={storeContact}
                        loading={loading}
                    />
                }
            >
                <div className="section">
                     <div className="row">
                        <div className="col-6">
                            <Input type={`text`} label={`Nome`} change={setName} value={name} />
                        </div>
                    </div>   
                    <div className="row">
                        <div className="col-6">
                            <Input type={`email`} label={`E-mail`} change={setEmail} value={email} />
                        </div>
                    </div>   
                    <div className="row">
                        <div className="col-6">
                            <Input type={`text`} label={`Telefone`} change={setPhone} value={phone} mask={`convertToPhone`} />
                        </div>
                    </div>                 
                </div>
            </Modal>
            <ModalDelete 
                show={customerToDelete !== null}
                action={deleteCustomer}
                close={() => setCustomerToDelete(null)}
                loading={loading}
            />
            {hasPermission('create_customer') &&
                <Button type={`secondary`} size={`small`} text={`Adicionar pessoa`} svg={`plus-blue`} action={() => createContact()} />
            }
            <br />
            <Table header={header} rows={rows} loading={loading} />
        </>
    );
}

const PriceTab = ({company, getCompany}) => {
    const [loading, setLoading] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showCreate, setShowCreate] = useState(false);

    const [priceId, setPriceId] = useState('');
    const [sku, setSku] = useState('');
    const [initQtd, setInitQtd] = useState('');
    const [finalQtd, setFinalQtd] = useState('');
    const [price, setPrice] = useState('');

    useEffect(() => {
        if(!showEdit) clean();
    }, [showEdit]);

    useEffect(() => {
        if(!showCreate) clean();
    }, [showCreate]);

    const updatePrice = () => {
        setLoading(true);
        api.put(`/company-price/${priceId}`, {
            company_id: company.id,
            sku,
            init_qtd: initQtd,
            final_qtd: finalQtd,
            price: convertMoenyToInt(price)
        }).then(res => {
            toast.success('Preço atualizado com sucesso');
            getCompany();
            setShowEdit(false);
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const updatePrices = () => {
        setLoading(true);
        api.get(`/sync/${company.id}`).then(res => {
            toast.success('Preços atualizados com sucesso');
            getCompany();
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const storePrice = () => {
        setLoading(true);
        api.post(`/company-price`, {
            company_id: company.id,
            sku,
            init_qtd: initQtd,
            final_qtd: finalQtd,
            price: convertMoenyToInt(price)
        }).then(res => {
            toast.success('Preço cadastrado com sucesso');
            getCompany();
            setShowEdit(false);
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const editPrice = price => {
        setShowEdit(true);
        setPriceId(price.id);
        setSku(price.sku);
        setInitQtd(price.init_qtd);
        setFinalQtd(price.final_qtd);
        setPrice( `R$ ${convertIntToMoney(price.price)}` );
    }

    const clean = () => {
        setPriceId('');
        setSku('');
        setInitQtd('');
        setFinalQtd('');
        setPrice('');
    }

    const header = ['SKU', 'Estoque', 'Quant. inicial', 'Quant. final', 'Preço'];
    const rows = [];

    company.prices.map(price => {
        rows.push({
            data: [price.sku, price.stock, price.init_qtd, price.final_qtd, `R$${price.formatted_price}` ],
            action: () => editPrice(price)
        });
    });

    const createPrice = () => {
        setShowCreate(true);
    }

    return (
        <>
            {company.type.includes('product') &&
                <>
                    <Modal
                        title={`Editar preço`}
                        show={showEdit}
                        close={() => setShowEdit(false)}
                        footer={
                            <>
                                {hasPermission('edit_company_table_price') &&
                                    <Button 
                                    type={`primary`}
                                    size={`small`}
                                    text={`Salvar alterações`}
                                    svg={`save-white`}
                                    action={updatePrice}
                                    loading={loading}
                                    />
                                }
                            </>
                        }
                    >
                        <div className="section">
                            <div className="row">
                                <div className="col-6">
                                    <Input type={`text`} label={`SKU`} change={setSku} value={sku} />
                                </div>
                            </div>   
                            <div className="row">
                                <div className="col-6">
                                    <Input type={`text`} label={`Quant. inicial`} change={setInitQtd} value={initQtd} />
                                </div>
                            </div>   
                            <div className="row">
                                <div className="col-6">
                                    <Input type={`text`} label={`Quant. final`} change={setFinalQtd} value={finalQtd} />
                                </div>
                            </div>   
                            <div className="row">
                                <div className="col-6">
                                    <Input type={`text`} label={`Preço`} change={setPrice} value={price} mask={`convertToMoney`} />
                                </div>
                            </div>               
                        </div>
                    </Modal>
                    <Modal
                        title={`Cadastrar preço`}
                        show={showCreate}
                        close={() => setShowCreate(false)}
                        footer={
                            <Button 
                                type={`primary`}
                                size={`small`}
                                text={`Cadastrar preço`}
                                svg={`save-white`}
                                action={storePrice}
                                loading={loading}
                            />
                        }
                    >
                        <div className="section">
                            <div className="row">
                                <div className="col-6">
                                    <Input type={`text`} label={`SKU`} change={setSku} value={sku} />
                                </div>
                            </div>   
                            <div className="row">
                                <div className="col-6">
                                    <Input type={`text`} label={`Quant. inicial`} change={setInitQtd} value={initQtd} />
                                </div>
                            </div>   
                            <div className="row">
                                <div className="col-6">
                                    <Input type={`text`} label={`Quant. final`} change={setFinalQtd} value={finalQtd} />
                                </div>
                            </div>   
                            <div className="row">
                                <div className="col-6">
                                    <Input type={`text`} label={`Preço`} change={setPrice} value={price} mask={`convertToMoney`} />
                                </div>
                            </div>                  
                        </div>
                    </Modal>
                    <PageHeader
                        left={
                            <>
                                {hasPermission('edit_company_table_price') && ['xbz', 'asiaimports'].includes(company.company_integration) &&
                                    <Button loading={loading} type={`primary`} size={`small`} text={`Buscar atualizações`} action={() => updatePrices()} />
                                }
                                {hasPermission('edit_company_table_price') &&
                                    <Button loading={loading} type={`secondary`} size={`small`} text={`Adicionar preço`} svg={`plus-blue`} action={() => createPrice()} />
                                }
                            </>
                        }
                    />
                    <br />
                    <Table header={header} rows={rows} loading={loading} />
                </>
            }
            {!company.type.includes('product') &&
                <p>Essa aba está disponível apenas para empresa com o marcador "Fornecedor de produto".</p>
            }
        </>
    );
}


export const CompanyEdit = () => {
    const { id } = useParams();
    const navigete = useNavigate();

    const [admins, setAdmins] = useState([]);
    const [tabs, setTabs] = useState([]);

    const [loading, setLoading] = useState(true);
    const [company, setCompany] = useState(null);
    const [tradeName, setTradeName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [cnpj, setCnpj] = useState("");

    const [phone, setPhone] = useState("");
    const [ie, setIe] = useState("");

    const [taxPercentage, setTaxPercentage] = useState('0,0000 %');

    const [zipCode, setZipCode] = useState("");
    const [street, setStreet] = useState("");
    const [number, setNumber] = useState("");
    const [complement, setComplement] = useState("");
    const [district, setDistrict] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");

    const [origin, setOrigin] = useState("");

    const [type, setType] = useState([]);
    const [admin, setAdmin] = useState(null);

    const [confirmDelete, setConfirmDelete] = useState(false);

    const [showCreateQuote, setShowCreateQuote] = useState(false);

    const [paperImageBase64, setPaperImageBase64] = useState('');
    const [paperImageName, setPaperImageName] = useState('');

    useEffect(() => {
        getAdmins();
        getCompany();
    }, [id]);

    useEffect(() => {
        getAddress();
    }, [zipCode]);

    const deleteCompany = () => {
        setLoading(true);

        api.delete(`/company/${id}`).then(res => {
            navigete(`/company/list`);
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const getAddress = () => {
        let convertedZipCode = zipCode.replace('-', '');
        if(convertedZipCode.length === 8){
            axios.get(`https://viacep.com.br/ws/${convertedZipCode}/json/`).then(res => {
                let address = res.data;
                setStreet(address.logradouro);
                setDistrict(address.bairro);
                setCity(address.localidade);
                setState(address.uf);
            })
        }
    }

    const getAdmins = () => {
        api.get(`/list`).then(res => {
            setAdmins(res.data.resources);
        });
    }

    const getCompany = () => {
        setLoading(true);

        api.get(`/company/${id}`).then(res => {
            console.log(res);
            const resource = res.data.resource;

            setCompany(resource);
            setAdmin(resource.admin_id);
            setType(resource.type);
            let toTabs = [
                'Detalhes da empresa',
                'Pessoas',
                'Orçamentos',
                'Pedidos'
            ];

            if(resource.type.includes('product')){
                toTabs.push('Tabela de preços');
            }

            setTabs(toTabs);

            setPhone(resource.phone);
            setIe(resource.ie);
            setPaperImageName(resource.paper_image ?? 'Sem imagem');

            setTaxPercentage( convertToPercentage(resource.tax_percentage ? resource.tax_percentage.toString() : '0') );
            
            setTradeName(resource.trade_name ?? '');
            setCompanyName(resource.company_name ?? '');
            setCnpj(resource.cnpj ?? '');
            setZipCode(resource.zip_code ?? '');
            setStreet(resource.street ?? '');
            setNumber(resource.number ?? '');
            setComplement(resource.complement ?? '');
            setDistrict(resource.district ?? '');
            setCity(resource.city ?? '');
            setState(resource.state ?? '');

            setOrigin(resource.origin ?? '');

        }).catch(error => {
            console.log(error)
            renderError(error);
        }).then(() => setLoading(false));
    }

    const updateCompany = () => {
        setLoading(true);
        api.put(`/company/${company.id}`, {
            ie,
            paper_image: paperImageBase64,
            phone,
            trade_name: tradeName,
            company_name: companyName,
            cnpj,
            type: type,
            tax_percentage: convertPercentageToInt(taxPercentage),
            zip_code: zipCode,
            street,
            admin_id: type.includes('customer') ? admin : null,
            number,
            district,
            city,
            state,
            complement,
            origin
        }).then(res => {
            getCompany();
            toast.success('Empresa atualizada com sucesso');
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const finishCreation = () => {
        navigete(`/quote/list`);
    }

    return (
        <>
            <ModalDelete
                show={confirmDelete}
                action={deleteCompany}
                close={() => setConfirmDelete(false)}
                loading={loading}
            />
            {showCreateQuote &&
                <ModalCreateQuote
                    close={() => setShowCreateQuote(false)}
                    finishCreation={finishCreation}
                    customerCompanyId={id}
                />
            }
            <PanelTemplate id="product-edit">
                <Loading show={loading} />
                {!loading && company?.original_company_id && (
                    <div className="company-duplicate-aviso">
                        <div className="company-duplicate-aviso__title">Empresa duplicada</div>
                        <div className="company-duplicate-aviso__content">
                            <div className="company-duplicate-aviso__row">
                                <div className="company-duplicate-aviso__item">
                                    <span className="company-duplicate-aviso__label">Data de cadastro desta empresa</span>
                                    <span className="company-duplicate-aviso__value">{company.created_at ? moment(company.created_at).format('DD/MM/YYYY [às] HH:mm') : '-'}</span>
                                </div>
                                <div className="company-duplicate-aviso__item">
                                    <span className="company-duplicate-aviso__label">Data de cadastro da empresa original</span>
                                    <span className="company-duplicate-aviso__value">{company.original_created_at ? moment(company.original_created_at).format('DD/MM/YYYY [às] HH:mm') : '-'}</span>
                                </div>
                                <div className="company-duplicate-aviso__item company-duplicate-aviso__item--fill">
                                    <span className="company-duplicate-aviso__label">Motivo (não considerada nova empresa)</span>
                                    <span className="company-duplicate-aviso__badge">{ORIGINAL_REASON_LABELS[company.original_reason] ?? company.original_reason}</span>
                                </div>
                            </div>
                            {company.original_company && (
                                <div className="company-duplicate-aviso__link-wrap">
                                    {company.original_company.admin_id !== undefined && company.original_company.admin_id !== getUser()?.id ? (
                                        <div className="company-duplicate-aviso__outro-responsavel">
                                            <span className="company-duplicate-aviso__outro-responsavel-icon" aria-hidden>ℹ</span>
                                            <span>A empresa original está vinculada a outro responsável. Você não tem acesso para visualizá-la.</span>
                                        </div>
                                    ) : (
                                        <Link to={`/company/edit/${company.original_company.id}`} className="company-duplicate-aviso__link">
                                            Ver empresa original
                                            {company.original_company.trade_name || company.original_company.company_name ? ` — ${company.original_company.trade_name || company.original_company.company_name}` : ''}
                                        </Link>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {!loading &&
                    <BoxTabs
                        titles={tabs}
                        contents={[
                            <CompanyDetailsTab
                                company={company}
                                type={type}
                                setType={setType}
                                admins={admins}
                                admin={admin}
                                setAdmin={setAdmin}
                                tradeName={tradeName}
                                setTradeName={setTradeName}
                                companyName={companyName}
                                setCompanyName={setCompanyName}
                                cnpj={cnpj}
                                setCnpj={setCnpj}
                                taxPercentage={taxPercentage}
                                setTaxPercentage={setTaxPercentage}
                                zipCode={zipCode}
                                setZipCode={setZipCode}
                                street={street}
                                setStreet={setStreet}
                                number={number}
                                setNumber={setNumber}
                                complement={complement}
                                setComplement={setComplement}
                                district={district}
                                setDistrict={setDistrict}
                                city={city}
                                setCity={setCity}
                                state={state}
                                setState={setState}
                                ie={ie}
                                setIe={setIe}
                                phone={phone}
                                setPhone={setPhone}
                                origin={origin}
                                setOrigin={setOrigin}
                                paperImageBase64={paperImageBase64}
                                setPaperImageBase64={setPaperImageBase64}
                                paperImageName={paperImageName}
                                setPaperImageName={setPaperImageName}
                            />,
                            <ContactsTab
                                company={company}
                                getCompany={getCompany}
                            />,
                            <QuotesTab
                                quotes={company.budgets}
                            />,
                            <OrdersTab
                                orders={company.orders}
                            />,
                            <PriceTab
                                company={company}
                                getCompany={getCompany}
                            />
                        ]}
                    />
                }
                <PageFooter spaceBetween={true}>
                    <>
                        <div>
                            {hasPermission('edit_company') &&
                                <Button type={`primary`} size={`small`} svg={`save-white`} text={`Salvar alterações`} action={updateCompany} />
                            }
                            {hasPermission('create_budget') &&
                                <Button type={`secondary`} size={`small`} text={`Criar orçamento`} action={() => setShowCreateQuote(true)} />
                            }
                        </div>
                        {hasPermission('delete_company') &&
                            <Button type={`secondary`} size={`small`} svg={`delete-small`} text={`Excluir`} action={() => setConfirmDelete(true)} />
                        }
                    </>
                </PageFooter>
            </PanelTemplate>
        </>
    );
}

export default CompanyEdit;